export default (state = { data: null }, { type, payload }) => {
  switch (type) {
    case 'POSITIONED_MODAL_OPEN':
      return {
        data: payload
      }
    case 'POSITIONED_MODAL_CLOSE':
      return {
        data: null
      }
    case 'LOGOUT':
      return {
        data: null
      }
    default:
      return state
  }
}